var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info',[_c('h1',[_vm._v(_vm._s(_vm.$t("TERMS OF SERVICE")))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('TERMS_OF_SERVICE_DESC_1', {domain: _vm.BRAND_CONFIG.domain}))}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('TERMS_OF_SERVICE_DESC_2'))}}),_c('html-with-links',{attrs:{"html":_vm.$t('TERMS_OF_SERVICE_DESC_3', {
        privacyLink: '/info/privacy',
      })}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('TERMS_OF_SERVICE_DESC_4'))}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('TERMS_OF_SERVICE_DESC_5'))}}),_c('html-with-links',{attrs:{"html":_vm.$t('TERMS_OF_SERVICE_DESC_6', {
        mailLink: 'mailto:appdb@protonmail.com',
      })}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }